import { createSelector } from "reselect";
import { StoreState } from "Store/Reducers";
import { EntityId } from "./PropTypes";

const fetchEntities = ({settings}: StoreState) => settings.entities;
const byName = (_: StoreState, name: any) => name;
const byId = (_: StoreState, id: EntityId) => id;


export const isEntityLoading = createSelector(
    fetchEntities,
    ({ _isFetching }) => _isFetching
)
export const isEntityPatching = createSelector(
    fetchEntities,
    ({ _isPatching }) => _isPatching
)

export const getEntities = createSelector(
    fetchEntities,
    ({ids, entities}) => ids?.map(i => entities?.[i])
);
export const getEntityIds = createSelector(fetchEntities, ({ids}) => (ids));
export const getEntitiesById = createSelector(fetchEntities, ({entities}) => (entities));
export const getEntitiesByName = createSelector(fetchEntities, ({byName}) => byName);

export const getEntityById = createSelector(fetchEntities, byId, ({entities}, id) => entities?.[id]);
export const getEntityByName = createSelector(
    fetchEntities,
    byName,
    ({ byName, entities }, name) => entities?.[byName?.[name]]
);

export const getEntityRelationById = createSelector(
    fetchEntities,
    byId,
    ({ entities }, id) => entities?.[id]?.relations
);